import React from "react";
import { Col, Form, Row } from "react-bootstrap";

import { useGameSummaryContext } from "../contexts/GameSummary";

import { displayFormAlert } from "../../../../../lib/utils";

const ScoreEntry = (): React.JSX.Element => {
    const { game, methods } = useGameSummaryContext();

    return (
        <section className="scoreEntry" data-testid="scoreEntry">
            <h3>Score Entry</h3>
            <Row>
                <Form.Group controlId="visitorScore" as={Col} sm={6}>
                    <Form.Label>{game.visitor.name} Score</Form.Label>
                    <Form.Control
                        type="text"
                        {...methods.register("scores.visitor", {
                            value: game?.visitor.score,
                        })}
                    />
                    {methods.formState.errors.scores?.visitor &&
                        displayFormAlert({
                            level: "danger",
                            text: methods.formState.errors.scores.visitor
                                .message as string,
                        })}
                </Form.Group>
                <Form.Group controlId="homeScore" as={Col} sm={6}>
                    <Form.Label>{game.home.name} Score</Form.Label>
                    <Form.Control
                        type="text"
                        {...methods.register("scores.home", {
                            value: game?.home.score,
                        })}
                    />
                    {methods.formState.errors.scores?.home &&
                        displayFormAlert({
                            level: "danger",
                            text: methods.formState.errors.scores.home
                                .message as string,
                        })}
                </Form.Group>
            </Row>
        </section>
    );
};

export default ScoreEntry;
